export const COOKIE_CONSENT_KEY = 'USE_COOKIE_CONSENT_STATE';
export const EMPTY_CONSENT = {};
//# sourceMappingURL=constants.js.map